import { FC, ReactNode } from 'react';

import { Box, Heading, Stack } from '@chakra-ui/react';

export const SectionGroup: FC<{ title?: string; actionSlot?: ReactNode; children: ReactNode }> = ({
  title,
  actionSlot,
  children,
}) => {
  return (
    <Box borderRadius='lg' border='2px' borderColor='light-blue' p={{ base: 4, lg: 8 }}>
      <Stack spacing={8}>
        <>
          {title && (
            <Heading as='h2' size='h3'>
              {title}
            </Heading>
          )}
          <Box>{children}</Box>
          {actionSlot && actionSlot}
        </>
      </Stack>
    </Box>
  );
};
